module.exports = __webpack_public_path__ + "85577a7bbba5b45d8c87db0bf2e3555c.pdf";